import navbarSearch from '../modules/navbar-search';
import commonAnalytics from '../modules/analytics/common';
import {initializeAdmin} from '../modules/admin/hamburger';

let commonController = () => {
    // require('../modules/adblock').on();
    require('../modules/optout')();
    require('../modules/hamburger').on();
    require('../modules/hamburger-sections')();
    navbarSearch();
    commonAnalytics();
    initializeAdmin();
};

export default commonController;
